import React from 'react';
import { Tab } from '@material-ui/core';
import TabContext from '@material-ui/lab/TabContext';
import TabPanel from '@material-ui/lab/TabPanel';
import PropTypes from 'prop-types';
import { Skeleton, TabList } from '@material-ui/lab';

export default function ExamTabPanel(props) {
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="tab-design">
      <TabContext value={value}>
        <TabList onChange={handleChange} className="line-tab">
          <Tab
            label={
              props.isFetching ? <Skeleton width={'100%'} /> : 'Test Pattern'
            }
            value="1"
          />
          <Tab
            label={props.isFetching ? <Skeleton width={'100%'} /> : 'Syllabus'}
            value="2"
          />
          <Tab
            label={
              props.isFetching ? <Skeleton width={'100%'} /> : 'Exam Center'
            }
            value="3"
          />
        </TabList>
        <TabPanel value="1">
          <pre>
            {props.MarkingScheme ? props.MarkingScheme : 'No Data available'}
          </pre>
        </TabPanel>
        <TabPanel value="2">
          <pre>{props.Syllabus ? props.Syllabus : 'No Data available'}</pre>
        </TabPanel>
        <TabPanel value="3">
          <pre>{props.TestCentre ? props.TestCentre : 'No Data available'}</pre>
        </TabPanel>
      </TabContext>
    </div>
  );
}

ExamTabPanel.propTypes = {
  MarkingScheme: PropTypes.string,
  Syllabus: PropTypes.string,
  TestCentre: PropTypes.string,
  isFetching: PropTypes.bool,
};
ExamTabPanel.defaultProps = {
  isFetching: false,
};
